import React, { useEffect, useState } from 'react';

import './ModalSlide.scss';
import { usePubSub } from './hooks/PubSubContext';

function ModalSlide(props) {

    const { publish, subscribe, unSubscribe } = usePubSub();

    const [modalData, setModalData] = useState(null);


    useEffect(() => {
        subscribe('openFullModal', handleOpenModal);
        subscribe('closeFullModal', handleCloseModal);

        return () => {
            unSubscribe('openFullModal');
            unSubscribe('closeFullModal');
        }
    }, []);

    useEffect(() => {
        if (modalData)
            document.getElementById(`modal-carousel-0`).checked = true;
    }, [modalData]);

    const handleOpenModal = (data) => {
        setModalData(data);
        //document.getElementById(`modal-carousel-0`).checked = true;
    }

    const handleCloseModal = () => {
        setModalData(null);
    }

    const handleClose = () => {
        setModalData(null);
    }

    const handleSelect = (idx) => {
        const newIdx = idx < 0 ? modalData?.contents?.length - 1 : idx > modalData?.contents?.length - 1 ? 0 : idx;
        document.getElementById(`modal-carousel-${newIdx}`).checked = true;

        document.querySelectorAll(".modal-carousel-bullet").forEach(el => el.classList.remove('selected'));
        document.getElementById(`modal-carousel-bullet-${newIdx}`).classList.add('selected');
    }

    const renderContent = (ct, idx) => {
        return (
            <div key={`modal_content_${idx}`}>
                <input className="modal-carousel-open" value={idx} type="radio" id={`modal-carousel-${idx}`} name="modal-carousel" aria-hidden="true" />
                <div className="modal-carousel-item">
                    {/* <h2 id='dlg-header'>{ct?.title}</h2>
                    <div id='dlg-content'>{ct?.content}</div> */}
                    {ct.content}
                    {
                        modalData?.contents?.length > 1 && <>
                            <span className={`modal-carousel-control prev `} onClick={() => { handleSelect(idx - 1) }} >‹</span>
                            <span className={`modal-carousel-control next `} onClick={() => { handleSelect(idx + 1) }}>›</span>
                        </>
                    }

                </div>
            </div>
        )
    }

    console.log(modalData?.showClose);


    return (
        <div>
            <input type="checkbox" name="dialog_state" id="dialog_state" className="dialog_state" checked={!!modalData} onChange={handleClose} />
            <div id='dialog'>
                <label id="dlg-back" htmlFor="dialog_state"></label>
                <div id='dlg-wrap'>
                    {
                        (modalData?.showClose === undefined || modalData?.showClose === true) &&
                        <label id="dlg-close" htmlFor="dialog_state"><i className='bx bx-x-circle icon'></i></label>
                    }
                    <div className="modal-carousel">
                        <div className="modal-carousel-inner">
                            {
                                modalData?.contents?.map((ct, idx) => renderContent(ct, idx))
                            }
                            <ol className="modal-carousel-indicators">
                                {
                                    modalData?.contents?.length > 1 && modalData?.contents?.map((ct, idx) =>
                                        <li key={`modal-carousel-bullet-${idx}`}>
                                            <span
                                                onClick={() => { handleSelect(idx) }}
                                                className="modal-carousel-bullet"
                                                id={`modal-carousel-bullet-${idx}`}
                                            >•</span>
                                        </li>
                                    )
                                }

                            </ol>
                        </div>
                    </div>

                    <div id='dlg-prompt'>
                        {
                            modalData?.buttons?.map((btn, idx) =>
                                <div
                                    className={`button ${btn.positive ? 'positive' : ''}`}
                                    key={`modal_dialog_button_${idx}`}
                                    onClick={(ev) => {
                                        console.log(btn.eventName);
                                        if (btn.onclick) btn.onclick(ev);
                                        else publish(btn.eventName, ev)
                                    }}
                                >
                                    {btn.label}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalSlide;